import { render, staticRenderFns } from "./DashboardRelancesList.vue?vue&type=template&id=1765e859&"
import script from "./DashboardRelancesList.vue?vue&type=script&lang=js&"
export * from "./DashboardRelancesList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardRelancesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports